import React, { FC, useMemo } from 'react';
import {
  ContForTiles,
  NoDataInfo,
  NoDataInfoCont,
  ReportPredictiveStatesTileCont,
} from './ReportPredictiveStatesTile.styles';
import ReportPredictiveStatesTileEL from './ReportPredictiveStatesTileEL/ReportPredictiveStatesTileEL';
import { useLocalSort } from '../../../hooks/useLocalSort';
import { IPredicTopic } from '../../../services/reports';

interface IReportPredictiveStatesTile {
  noDataInfo: string;
  sortKey: string;
  topicResults?: IPredicTopic[];
  isTotalsTabActive: boolean;
}
const ReportPredictiveStatesTile: FC<IReportPredictiveStatesTile> = ({
  noDataInfo,
  sortKey,
  topicResults,
  isTotalsTabActive,
}) => {
  const items = topicResults ? [...topicResults] : [];
  const { sortItems } = useLocalSort([...items], 'predictiveStates', sortKey);

  const renderAccordion = useMemo(() => {
    return sortItems?.map((state: IPredicTopic) => (
      <ReportPredictiveStatesTileEL
        key={state?.topic?.code}
        stateData={state}
        filterKey={sortKey}
        isTotalsTabActive={isTotalsTabActive}
      />
    ));
  }, [sortItems, isTotalsTabActive]);

  return (
    <ReportPredictiveStatesTileCont id="ReportPredictiveStatesTileCont">
      <ContForTiles>
        {sortItems.length > 0 ? (
          renderAccordion
        ) : (
          <NoDataInfoCont>
            <NoDataInfo>{noDataInfo}</NoDataInfo>
          </NoDataInfoCont>
        )}
      </ContForTiles>
    </ReportPredictiveStatesTileCont>
  );
};
export default ReportPredictiveStatesTile;
